import { root } from './timezones';

export const timezones = {
  ...root,
};
